import { render, staticRenderFns } from "./CustomerOperations.vue?vue&type=template&id=7febe972"
import script from "./CustomerOperations.vue?vue&type=script&lang=js"
export * from "./CustomerOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports